/**
 * Appends query string parameters to a URL.
 *
 * @param url - The URL to append the query string parameters to.
 * @param params - An object containing the query string parameters as key-value pairs.
 * @returns The modified URL with the appended query string parameters.
 */
const appendQueryString = (url: string, params: Record<string, string>): string => {
  const urlObject = new URL(url);

  Object.entries(params).forEach(([key, value]) => {
    urlObject.searchParams.append(key, value);
  });

  return urlObject.toString();
};

export default appendQueryString;
